import { Action, createReducer, on } from '@ngrx/store';
import { Session } from '@ory/client';

import { BusinessUnit } from '@aw/prypco/enums';
import {
  AccountStates,
  ExternalIdentifier,
  UserInfo,
} from '@aw/prypco/services/user';

import { setAccountState } from './auth-state.util';
import * as AuthActions from './auth.actions';
import { LeadIdRecord } from './models/entities/lead-id-record.model';
import { LeadRecord } from './models/entities/lead-record.model';
import { MemberInfoCustomer } from './models/entities/member-info.model';

export const featureKey = 'auth';
export interface AuthPartialState {
  readonly [featureKey]: State;
}
export interface State {
  session?: Session;

  userInfo?: UserInfo;
  accountStates?: Record<BusinessUnit, AccountStates>;
  customer?: MemberInfoCustomer;

  externalIdentifiers: Array<ExternalIdentifier>;
  leadIdRecord: LeadIdRecord;
  leadRecord: LeadRecord;
  initialized: boolean;
  loading: boolean;
  remoteConfig: Record<string, any>;
}

export const initialState: State = {
  session: undefined,
  userInfo: undefined,
  accountStates: undefined,
  customer: undefined,
  externalIdentifiers: [],
  leadIdRecord: {},
  leadRecord: {},
  initialized: false,
  loading: false,
  remoteConfig: {},
};

const authReducer = createReducer(
  initialState,
  on(AuthActions.init, () => ({
    ...initialState,
    initialized: false,
    loading: true,
  })),
  on(AuthActions.logOut, () => ({
    ...initialState,
  })),
  on(
    AuthActions.setMemberInfo,
    (
      state,
      {
        accountStates,
        customer,
        leadRecord,
        leadIdRecord,
        externalIdentifiers,
      },
    ) => ({
      ...state,
      leadIdRecord: { ...leadIdRecord },
      leadRecord: { ...leadRecord },
      accountStates,
      externalIdentifiers,
      initialized: true,
      loading: false,
      customer,
    }),
  ),
  on(AuthActions.setLeadId, (state, { leadId, businessUnit }) => ({
    ...state,
    leadIdRecord: {
      ...state.leadIdRecord,
      [businessUnit]: leadId,
    },
  })),
  on(AuthActions.setLead, (state, { lead, businessUnit }) => ({
    ...state,
    leadRecord: {
      ...state.leadRecord,
      [businessUnit]: lead,
    },
  })),
  on(AuthActions.setAccountStates, (state, { accountStates }) => ({
    ...state,
    accountStates,
    loading: false,
  })),
  on(AuthActions.refreshAccountStates, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AuthActions.setAccountState,
    (state, { businessUnit, accountState, value }) => ({
      ...state,
      accountStates: setAccountState(state, businessUnit, accountState, value),
    }),
  ),
  on(AuthActions.setInitialized, (state) => ({
    ...state,
    initialized: true,
    loading: false,
  })),
  on(AuthActions.setRemoteConfig, (state, { config }) => ({
    ...state,
    remoteConfig: config,
  })),  
);

export function reducer(state: State | undefined, action: Action) {
  return authReducer(state, action);
}
